import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Users, ExternalLink } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { useRecentConnections } from '@/hooks/useCampaignDashboard';

export function RecentConnectionsCard() {
  const { data: connections, isLoading } = useRecentConnections(5);

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">Recent Connections</CardTitle>
          </div>
          <Link to="/campaigns">
            <ExternalLink className="h-4 w-4 text-muted-foreground hover:text-primary transition-colors" />
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => <Skeleton key={i} className="h-14 w-full" />)}
          </div>
        ) : !connections?.length ? (
          <p className="text-sm text-muted-foreground text-center py-6">No recent connections</p>
        ) : (
          <div className="space-y-2">
            {connections.map((conn, i) => (
              <div key={i} className="p-2.5 rounded-lg hover:bg-accent/50 transition-colors">
                <p className="text-sm font-medium">{conn.full_name || 'Unknown'}</p>
                <div className="flex items-center gap-2 mt-0.5 text-xs text-muted-foreground">
                  {conn.company_name && <span className="font-medium text-foreground/70">{conn.company_name}</span>}
                  {conn.headline && <span className="truncate">· {conn.headline}</span>}
                </div>
                {conn.connection_accepted_at && (
                  <p className="text-[11px] text-muted-foreground mt-0.5">
                    Connected {formatDistanceToNow(new Date(conn.connection_accepted_at), { addSuffix: true })}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
        <div className="pt-3 text-center">
          <Link to="/campaigns" className="text-xs text-primary hover:underline font-medium">
            View All Connections →
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
